import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormTextField from 'icw-components/FormTextField';
import FormDropDownList from 'icw-components/FormDropDownList';
import AppBar from 'icw-components/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { ItemGrid } from 'components';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import {
  actAnyFieldUpdate,
  actAnyFieldRemove,
  actCloneObject,
  getValue,
} from 'actions/formActions';

const styles = (theme) => ({
  actionButton: {
    border: 0,
    right: 0,
    position: 'absolute',
  },
  arrowForward: {
    position: 'absolute',
    top: '50%',
    right: '18%',
  },
  arrowForwardFull: {
    position: 'absolute',
    top: '50%',
    right: 0,
  },
  arrowBackward: {
    position: 'absolute',
    top: '50%',
    left: 0,
  },
  block: {
    display: 'flex',
  },
  hidden: {
    display: 'none',
  },
  icon: {
    fontSize: '36px',
  },
  iconMargin: {
    marginRight: '30px',
  },
  duplicatedIconMargin: {
    marginRight: '56px',
  },
  iconButton: {
    width: 'auto',
    height: 'auto',
  },
  table: {
    background:
      'linear-gradient(269.58deg, rgba(0, 0, 0, 0.11) 0.19%, rgba(255, 255, 255, 0) 2.98%)',
    overflow: 'auto',
    display: 'block',
  },
  tableCell: {
    minWidth: '150px',
  },
  tableFooter: {
    margin: '20px 0',
    textAlign: 'center',
    left: '50%',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  root: {
    minWidth: 700,
    marginBottom: '20px',
    paddingBottom: '20px',
    position: 'relative',
  },
  paddingBlock: {
    padding: '20px 0',
  },
});

class FormTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      arrowIcon: false,
    };

    this.handleOnLeftScroll = this.handleOnLeftScroll.bind(this);
    this.handleOnRightScroll = this.handleOnRightScroll.bind(this);
    this.handleButtonAction = this.handleButtonAction.bind(this);
    this.handleRenderComponent = this.handleRenderComponent.bind(this);
  }

  handleOnLeftScroll = (tableId) => {
    const scrollWidth = document.getElementById(tableId).scrollLeft;

    if (scrollWidth > 0) {
      document.getElementById(tableId).scrollLeft =
        document.getElementById('fullTable').offsetWidth + 700;
    } else {
      document.getElementById(tableId).scrollLeft = document.getElementById(tableId).offsetWidth;
    }

    this.setState({
      arrowIcon: true,
    });
  };

  handleOnRightScroll = (tableId) => {
    const scrollWidth = document.getElementById(tableId).scrollLeft;

    if (scrollWidth <= document.getElementById(tableId).offsetWidth) {
      document.getElementById(tableId).scrollLeft = 0;
      this.setState({
        arrowIcon: false,
      });
    } else {
      document.getElementById(tableId).scrollLeft = document.getElementById(tableId).offsetWidth;
    }
  };

  handleButtonAction = (index, action, storeName, accessPath) => {
    const { onRemoveNestedRecord, onCloneObject } = this.props;
    if (action === 'Delete') {
      onRemoveNestedRecord(storeName, [...accessPath, index]);
    }
    if (action === 'Duplicate') {
      onCloneObject(storeName, accessPath, index);
    }
  };

  handleRenderComponent = (
    type,
    storeName,
    accessPath,
    idx,
    columnId,
    choices,
    noEdit,
    dataType
  ) => {
    const { state, classes, onFieldUpdate } = this.props;
    const getData = getValue(state[storeName].data, [...accessPath, idx, columnId]);

    switch (type) {
      case 'input':
        return (
          <FormTextField
            storeName={storeName}
            dataType={dataType}
            accessPath={[...accessPath, idx, columnId]}
            InputLabelProps={{ shrink: true }}
          />
        );
      case 'select':
        return (
          <FormDropDownList
            storeName={storeName}
            accessPath={[...accessPath, idx, columnId]}
            InputLabelProps={{ shrink: true }}
            choices={choices}
            noMargin
          />
        );
      case 'check':
        return (
          <Checkbox
            onChange={(e) => {
              onFieldUpdate(storeName, [...accessPath, idx, columnId], e.target.checked);
            }}
            checked={getData ? true : false}
            disabled={noEdit ? true : false}
          />
        );
      default:
        return choices && choices.length > 0 ? (
          <Typography className={classes.paddingBlock} variant='subtitle1' paragraph>
            {getData && choices.find((pc) => pc.value === getData).label}
          </Typography>
        ) : (
          <Typography className={classes.paddingBlock} variant='subtitle1' paragraph>
            {getData}
          </Typography>
        );
    }
  };

  render() {
    const {
      classes,
      menuBar,
      title,
      tableId,
      tableHeader,
      tableBody,
      columnData,
      tableFooter,
      edit,
    } = this.props;

    const tableWidth = edit ? 10 : 12;

    return (
      <Paper className={classes.root}>
        <AppBar title={title} menuBar={menuBar} />
        <div className={classes.block} id='fullTable'>
          <ItemGrid xs={tableWidth} sm={tableWidth} md={tableWidth} noPadding>
            <Table className={classes.table} id={tableId}>
              <TableHead>
                <TableRow>
                  {tableHeader &&
                    tableHeader.map((props, index) => <TableCell key={index}>{props}</TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableBody &&
                  tableBody.map((row, idx) => (
                    <TableRow key={idx}>
                      {columnData &&
                        columnData.map((column, columnIdx) => {
                          const {
                            type,
                            classId,
                            columnId,
                            storeName,
                            accessPath,
                            actionButton,
                            actionTitle,
                            actionLabel,
                            render,
                            choices,
                            noEdit,
                            dataType,
                          } = column;
                          return actionButton && actionButton ? (
                            <Tooltip title={actionLabel} key={columnId}>
                              <TableCell className={classes.actionButton}>
                                <IconButton
                                  className={classes[classId]}
                                  onClick={(e) =>
                                    this.handleButtonAction(idx, actionTitle, storeName, accessPath)
                                  }>
                                  {render()}
                                </IconButton>
                              </TableCell>
                            </Tooltip>
                          ) : (
                            <TableCell className={classes.tableCell} key={columnId}>
                              {this.handleRenderComponent(
                                type,
                                storeName,
                                accessPath,
                                idx,
                                columnId,
                                choices,
                                noEdit,
                                dataType
                              )}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </ItemGrid>
        </div>
        <div className={classes.tableFooter}>{tableFooter}</div>
      </Paper>
    );
  }
}

FormTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  state: state,
});

const mapDispatchToProps = (dispatch) => ({
  onFieldUpdate: (storeName, accessPath, newVal) => {
    dispatch(actAnyFieldUpdate(storeName, accessPath, newVal));
  },
  onRemoveNestedRecord: (storeName, accessPath) => {
    dispatch(actAnyFieldRemove(storeName, accessPath));
  },
  onCloneObject: (storeName, accessPath, idx) => {
    dispatch(actCloneObject(storeName, accessPath, idx));
  },
});

const FormTableContainer = connect(mapStateToProps, mapDispatchToProps)(FormTable);

export default withStyles(styles)(FormTableContainer);
